// extracted by mini-css-extract-plugin
export default {"spinner":"_1Je28","loggedInStakeContainer":"_1ZJxD","emptyStakeText":"_1XDx6"};